import { useEffect, useState } from "react";

export type UiLang = "ar" | "en";

const STORAGE_KEY = "ui_lang";

function detect(): UiLang {
  if (typeof window === "undefined") return "ar";
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "ar" || stored === "en") return stored;
  const htmlLang = document.documentElement.lang?.toLowerCase();
  if (htmlLang?.startsWith("en")) return "en";
  if (htmlLang?.startsWith("ar")) return "ar";
  const nav = (navigator.language || "ar").toLowerCase();
  return nav.startsWith("en") ? "en" : "ar";
}

export function useUiLanguage(): UiLang {
  const [lang, setLang] = useState<UiLang>(() => detect());

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) setLang(detect());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return lang;
}
